export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openLog({commit}) {
        commit('openLog');
    },
    openCert({commit}) {
        commit('openCert');
    }
}
